// HeaderBar.js — Wallet, Mail, Bell icons row
import React from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';
import { Ionicons as Icon } from '@expo/vector-icons';
import { Colors } from '../constants/colors';

export default function HeaderBar({ navigation, walletCount }) {
  return (
    <View style={s.row}>
      <TouchableOpacity onPress={function() { navigation.navigate('Wallet'); }} style={s.btn}>
        <Icon name="wallet-outline" size={22} color={Colors.textMid} />
        {walletCount > 0 && (
          <View style={s.badge}>
            <Icon name="checkmark" size={8} color="#fff" />
          </View>
        )}
      </TouchableOpacity>
      <TouchableOpacity onPress={function() { navigation.navigate('Inbox'); }} style={s.btn}>
        <Icon name="mail-outline" size={20} color={Colors.textMid} />
        <View style={[s.badge, { backgroundColor: Colors.danger }]}>
          <Icon name="ellipse" size={4} color="#fff" />
        </View>
      </TouchableOpacity>
      <TouchableOpacity onPress={function() { navigation.navigate('Notifications'); }} style={s.btn}>
        <Icon name="notifications-outline" size={20} color={Colors.textMid} />
        <View style={[s.badge, { backgroundColor: Colors.coral }]}>
          <Icon name="ellipse" size={4} color="#fff" />
        </View>
      </TouchableOpacity>
    </View>
  );
}

var s = StyleSheet.create({
  row: { flexDirection: 'row', justifyContent: 'flex-end', gap: 8, paddingHorizontal: 20, paddingTop: 4 },
  btn: { position: 'relative', padding: 2 },
  badge: { position: 'absolute', top: -2, right: -2, width: 14, height: 14, borderRadius: 7, backgroundColor: Colors.green, alignItems: 'center', justifyContent: 'center' },
});
